import React from 'react';
import { useNavigate } from 'react-router-dom';
import { NButton } from '@innersource-nn/novoui-react';

export default function TableActionButton({
    path,
}: {
    path: string;
    onClickExtra?: () => void;
}) {
    const navigate = useNavigate();

    const handleClick = (
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    ) => {
        const fullPath = `${window.location.origin}${path}`;
        if (event.ctrlKey || event.metaKey) {
            window.open(fullPath, '_blank');
        } else {
            navigate(path);
        }
    };

    return (
        <NButton
            size="tiny"
            variant="outline"
            icon="arrowRight"
            square
            onClick={handleClick}
        />
    );
}
